<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card header="Detalle">
          <b-row class="form-group">
            <b-col sm="5">
              <label for>Nombre de Nave</label>
              <input type="text" v-model="portage.ship_name" class="form-control">
            </b-col>
            <b-col sm="5">
              <label for>Linea Naviera</label>
              <input type="text" v-model="portage.shipping_line.name" class="form-control" disabled>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col sm="5">
              <label for>Tipo de operación</label>
              <input type="text" :value="portage.operation.name" class="form-control" disabled>
            </b-col>
            <b-col sm="5">
              <label for>ETB</label>
              <br>
              <date-picker
                v-model="portage.etb"
                lang="es"
                type="datetime"
                required
                format="DD/MM/YYYY HH:mm"
                :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
              ></date-picker>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col sm="5">
              <label for>{{isImpo ? 'Cierre' : 'Cut Off'}}</label>
              <br>
              <date-picker
                v-model="portage.cutoff"
                lang="es"
                type="datetime"
                required
                format="DD/MM/YYYY HH:mm"
                :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
              ></date-picker>
            </b-col>
            <b-col sm="5">
              <label for>{{isImpo ? 'TD' : 'Stacking'}}</label>
              <br>
              <date-picker
                v-model="isImpo ? portage.td : portage.stacking"
                lang="es"
                type="datetime"
                required
                format="DD/MM/YYYY HH:mm"
                :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
              ></date-picker>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col sm="5">
              <label for>Cantidad de contenedores</label>
              <input type="text" :value="portage.total_containers" class="form-control" disabled>
            </b-col>
            <b-col sm="5">
              <label for>Puerto</label>
              <input type="text" :value="portage.port.name" class="form-control" disabled>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="5">
              <b-button type="button" variant="primary" @click="updatePortage()">Guardar Cambios</b-button>
            </b-col>
            <b-col v-if="isDpw" sm="2">
              <b-button type="button" variant="primary" @click="openAppointments()">Agregar Citas</b-button>
            </b-col>
          </b-row>
        </b-card>
        <b-card header="Requerimientos sin asignar">
          <div class="table-responsive">
            <div class="pull-left">
              <button
                class="btn btn-danger"
                :disabled="selectedUnassigned.length <= 0"
                @click="updateRqs(constants.ANULADO_TRAMARSA)"
              >Anular</button>
            </div>
            <div class="form-group form-inline pull-right">
              <button class="btn btn-warning" @click="assign()">Programar</button>&nbsp;
              <button class="btn btn-primary" @click="openRqs()">Agregar Requerimientos</button>
            </div>
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>
                    <label class="form-checkbox">
                      <input type="checkbox" v-model="selectAllUnassigned" @click="select(0)">
                    </label>
                  </th>
                  <th>#RQ</th>
                  <th v-if="['ECE', 'DCE'].includes(portage.operation.code)">Tipo de Carga</th>
                  <th>Contenedor</th>
                  <th v-if="isDpw">Código de cita</th>
                  <th v-if="isDpw">Fecha de cita</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  @contextmenu.prevent="selectRq(rq, false)"
                  v-for="(rq,k) in paginated('unassignedRqs')"
                  :key="k"
                >
                  <td>
                    <input type="checkbox" :value="rq.id" v-model="selectedUnassigned">
                  </td>
                  <td>{{rq.id}}</td>
                  <td
                    v-if="['ECE', 'DCE'].includes(portage.operation.code)"
                  >{{rq.charge_type ? rq.charge_type.name : ""}}</td>
                  <td>{{rq.container_number}}</td>
                  <td v-if="isDpw">
                    <a
                      href="javascript:void(0);"
                      @click="openAppointment(rq)"
                    >{{rq.appointment_code ? rq.appointment_code : 'Agregar cita'}}</a>
                  </td>
                  <td v-if="isDpw">{{rq.appointment_date | formatDateTime}}</td>
                </tr>
              </tbody>
            </table>
            <paginate name="unassignedRqs" :list="unassignedRqs" class="paginate-list" :per="10"></paginate>
            <paginate-links
              for="unassignedRqs"
              :limit="5"
              :show-step-links="true"
              :step-links="{
                next: '>>',
                prev: '<<'
              }"
              :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
            ></paginate-links>
          </div>
        </b-card>
        <b-card header="Requerimientos asignados">
          <div class="table-responsive">
            <div class="pull-left">
              <button
                class="btn btn-danger"
                :disabled="selectedAssigned.length <= 0"
                @click="updateRqs(constants.FINALIZADO)"
              >Finalizar</button>
            </div>
            <div class="form-group form-inline pull-right">
              <input type="text" v-model="search" placeholder="Buscar" class="form-control"> &nbsp;
              <select v-model="truckUnassign.id" class="form-control" required>
                <option value>Seleccione camión</option>
                <option v-for="(truck,k) in trucks" :key="k" :value="truck.id">{{truck.plate}}</option>
              </select>&nbsp;
              <button @click="unassignTruck" type="button" class="btn btn-primary">Desasignar</button>
            </div>
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>
                    <label class="form-checkbox">
                      <input type="checkbox" v-model="selectAllAssigned" @click="select(1)">
                    </label>
                  </th>
                  <th>#RQ</th>
                  <th>SINI</th>
                  <th v-if="['ECE', 'DCE'].includes(portage.operation.code)">Tipo de Carga</th>
                  <th>Contenedor</th>
                  <th>Camión</th>
                  <th>Conductor</th>
                  <th v-if="isDpw">Código de cita</th>
                  <th>Fecha de cita</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(rq,j) in paginated('assignedRqs')"
                  :key="j"
                  @contextmenu.prevent="selectRq(rq, true)"
                >
                  <td>
                    <input
                      type="checkbox"
                      :value="rq.id"
                      v-model="selectedAssigned"
                      v-if="rq.status.code !== constants.FINALIZADO"
                    >
                  </td>
                  <td>{{rq.id}}</td>
                  <td>
                    <input type="checkbox" v-model="rq.sini" @click="changeSINI(rq.id, rq.sini)" />
                  </td>
                  <td
                    v-if="['ECE', 'DCE'].includes(portage.operation.code)"
                  >{{rq.charge_type ? rq.charge_type.name : ""}}</td>
                  <td>{{rq.container_number}}</td>
                  <td>{{rq.truck ? rq.truck.plate : ''}}</td>
                  <td>{{rq.driver ? `${rq.driver.name} ${rq.driver.last_name}` : ''}}</td>
                  <td v-if="isDpw">
                    <a
                      href="javascript:void(0);"
                      @click="openAppointment(rq)"
                    >{{rq.appointment_code ? rq.appointment_code : 'Agregar cita'}}</a>
                  </td>
                  <td>{{rq.appointment_date | formatDateTime}}</td>
                  <td>{{rq.status.name}}</td>
                </tr>
              </tbody>
            </table>
            <paginate name="assignedRqs" :list="assignedRqs" class="paginate-list" :per="10"></paginate>
            <paginate-links
              for="assignedRqs"
              :limit="5"
              :show-step-links="true"
              :step-links="{
                next: '>>',
                prev: '<<'
              }"
              :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
            ></paginate-links>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <context-menu id="context-menu" ref="ctxMenu">
      <li v-on:click="showModal=true" class="ctx-item">Asignar</li>
    </context-menu>

    <context-menu id="context-menu" ref="ctxMenuAssigned">
      <li v-on:click="detailRq" class="ctx-item">Detalle</li>
    </context-menu>
    <ModalTrucks
      :showModal="showModal"
      :requeriment="requeriment"
      :statuses="statuses"
      :isDpw="isDpw"
      :portage="portage"
      @close="close"
    />
    <ModalAppointment
      :showModalAppointment="showModalAppointment"
      :requeriment="requeriment"
      @close="closeModalAppointment"
    />
    <ModalAddAppointments
      :showModalAppointments="showModalAppointments"
      :specialOperation="['ECE', 'DCE'].includes(portage.operation.code)"
      :specialChargeTypes="specialChargeTypes"
      :addAppointments="addAppointments"
      :port="portage.port"
      :cutoff="portage.cutoff"
      :containersByCharge="containersByCharge"
      @close="closeModalAppointment"
    />
    <ModalRqs
      :showModalRqs="showModalRqs"
      :specialOperation="['ECE', 'DCE'].includes(portage.operation.code)"
      :specialChargeTypes="specialChargeTypes"
      :addRqs="addRqs"
      @close="closeModalAppointment"
    />
    <div
      v-if="showModal || showModalAppointment || showModalAppointments || showModalRqs"
      class="modal-backdrop fade show"
    ></div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import moment from "moment";
import constants from "@/constants";
import contextMenu from "vue-context-menu";
import ModalTrucks from "../requeriments/ModalTrucks";
import ModalAppointment from "./ModalAppointment";
import ModalAddAppointments from "./ModalAddAppointments";
import ModalRqs from "./ModalRqs";

export default {
  components: {
    ModalTrucks,
    ModalAppointment,
    ModalAddAppointments,
    contextMenu,
    ModalRqs
  },
  data() {
    return {
      paginate: ["unassignedRqs", "assignedRqs"],
      rqs: [],
      search: "",
      portage: {
        shipping_line: {},
        port: {},
        operation: {}
      },
      id: this.$route.params.id,
      requeriment: {},
      showModal: false,
      statuses: [],
      trucks: [],
      truckSelected: "",
      truckUnassign: { id: "" },
      showModalAppointment: false,
      showModalAppointments: false,
      showModalRqs: false,
      selectedAssigned: [],
      selectedUnassigned: [],
      selectAllAssigned: false,
      selectAllUnassigned: false,
      containersByCharge: {},
      specialChargeTypes: [],
      isImpo: false,
      isDpw: false
    };
  },
  mounted() {
    api.get("/charge_types").then(response => {
      this.specialChargeTypes = response.charge_types.filter(s => s.portage);
    });
    api.get(`/portage/${this.id}`).then(response => {
      this.rqs = response.requeriments.filter(
        rq => rq.status.code != this.constants.ANULADO_TRAMARSA
      );
      this.portage = response.portage;
      this.isImpo = this.portage.operation.code_service === "IMPO";
      this.isDpw = this.portage.port.code === "DPW";
      this.setContainerByCharge();
      this.setUsedTrucks();
    });
    api.get("/statuses").then(response => {
      this.statuses = response.status;
    });

    this.constants = constants;
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : null;
    },
    changeSINI(requeriment_id, sini){
      api.put(`requeriments/${requeriment_id}`, {sini: !sini}).then(response => {
        this.$toastr.success('Revisión en SINI actualizada.', "Porteo", {
          positionClass: "toast-top-center",
          closeButton: true
        });  
      })
    },
    showSuccess(label) {
      this.$toastr.success(label, "Porteo", {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    showError(label) {
      this.$toastr.error(label, "Porteo", {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    updatePortage() {
      const { cutoff, etb, ship_name, td, stacking } = this.portage;
      const data = {
        cutoff: this.formatDate(cutoff),
        etb: this.formatDate(etb),
        ship_name,
        td: this.formatDate(td),
        stacking: this.formatDate(stacking)
      };
      api.put(`portages/${this.id}`, data).then(res => {
        this.showSuccess("Porteo actualizado.");
      });
    },
    assign() {
      let apiUrl = "";
      const current_date = moment().format("YYYY-MM-DD HH:mm:ss");
      let flag_confirm = false;
      if (this.isDpw) {
        apiUrl = `assign_dpw/${this.id}`;
        flag_confirm = true;
      } else {
        apiUrl = `assign_apm/${this.id}`;

        const initial_date = this.isImpo
          ? this.portage.td
          : this.portage.stacking;
        const start_date =
          current_date > initial_date
            ? moment(current_date)
                .add(
                  this.portage.port.cycle_time * this.portage.port.timeframe,
                  "minutes"
                )
                .format("YYYY-MM-DD HH:mm:00")
            : initial_date;
        const unassign = current_date > initial_date ? true : false;

        if (
          unassign && 
          confirm(
            `Se reprogramarán todas las citas a partir de las ${moment(
              start_date
            ).format("HH:mm")} hrs. del día ${moment(start_date).format(
              "DD/MM/YYYY"
            )}, incluyendo aquellas asignadas de manera manual, ¿Seguro deseas reprogramar?`
          )
        ) {
          flag_confirm = true;
        } else {
          flag_confirm = true;
        }
      }

      if (flag_confirm) {
        api.get(apiUrl).then(
          response => {
            this.$toastr.info(response.message, "Porteo", {
              positionClass: "toast-top-center",
              closeButton: true
            });
          },
          error => {
            this.$toastr.error(error.message, "Porteo", {
              positionClass: "toast-top-center",
              closeButton: true
            });
          }
        );
      }
    },
    addRqs(initialData) {
      const data = initialData;
      data.id = this.id;
      if (["ECE", "DCE"].includes(this.portage.operation.code))
        data.charge_type_id = data.chargeType.id;

      api.post("/add_portage_rqs", data).then(res => {
        this.rqs = res.requeriments;
        this.portage.total_containers += data.quantity;
        this.showSuccess(`Se agregaron ${data.quantity} requerimientos.`);
      });
    },
    selectRq(rq, flag) {
      this.requeriment = rq;
      if (this.isDpw && !rq.appointment_code) return false;

      if (flag) this.$refs.ctxMenuAssigned.open();
      else this.$refs.ctxMenu.open();
    },
    setContainerByCharge() {
      let vm = this;
      vm.specialChargeTypes.map(sch => {
        vm.containersByCharge[sch.id] = vm.rqs.filter(
          rq => rq.charge_type_id === sch.id && !rq.appointment_code
        ).length;
      });
    },
    setUsedTrucks() {
      this.trucks = [];
      let assignedRqs = this.rqs.filter(rq => rq.truck_id);
      const map = new Map();
      for (const item of assignedRqs.map(rq => rq.truck)) {
        if (!map.has(item.id)) {
          map.set(item.id, true);
          this.trucks.push({
            id: item.id,
            plate: item.plate
          });
        }
      }
    },
    unassignTruck() {
      const { id } = this.truckUnassign;
      if (id) {
        const rqs = this.rqs.filter(
          rq => rq.truck_id === id && rq.status.code !== constants.FINALIZADO
        );
        const rqIds = rqs.map(rq => rq.id);
        api.post("/unsassign_rqs", { rqs: rqIds }).then(res => {
          rqs.map(rq => {
            const index = this.rqs.findIndex(r => r.id === rq.id);
            const newRq = { ...rq, truck_id: null };
            this.rqs.splice(index, 1, newRq);
          });
          this.setUsedTrucks();
        });
      }
    },
    detailRq() {
      this.$router.push(`/requeriments/import/detail/${this.requeriment.id}`);
    },
    close(rq) {
      this.showModal = false;
      if (rq) {
        const index = this.rqs.findIndex(item => item.id === rq.id);
        const aux = this.rqs.find(item => item.id === rq.id);
        this.rqs.splice(index, 1, aux);
      }
    },
    openAppointment(rq) {
      this.requeriment = rq;
      this.showModalAppointment = true;
    },
    closeModalAppointment() {
      this.showModalAppointment = false;
      this.showModalRqs = false;
      this.showModalAppointments = false;
    },
    openAppointments() {
      this.showModalAppointments = true;
    },
    openRqs() {
      this.showModalRqs = true;
    },
    select(finalize) {
      this.selectedUnassigned = [];
      this.selectedAssigned = [];
      if (finalize && !this.selectAllAssigned) {
        for (let i in this.assignedRqs) {
          if (this.assignedRqs[i].status.code !== constants.FINALIZADO) {
            this.selectedAssigned.push(this.assignedRqs[i].id);
          }
        }
      } else if (!finalize && !this.selectAllUnassigned) {
        for (let i in this.unassignedRqs) {
          this.selectedUnassigned.push(this.unassignedRqs[i].id);
        }
      }
    },
    updateRqs(code) {
      const { selectedAssigned, selectedUnassigned, constants, rqs } = this;
      let selected, questionLabel, infoLabel;
      const finish = code === constants.FINALIZADO;
      if (finish) {
        selected = selectedAssigned;
        questionLabel = "finalizar";
        infoLabel = "finalizados";
      } else {
        selected = selectedUnassigned;
        questionLabel = "anular";
        infoLabel = "anulados";
      }
      if (
        confirm(
          `¿Seguro desea ${questionLabel} los requerimientos seleccionados?`
        )
      ) {
        api
          .post("finalize_requeriments", {
            rqs_ids: selected,
            service_id: this.id,
            status_code: code
          })
          .then(
            response => {
              this.$toastr.success(`Requerimientos ${infoLabel}.`, "Porteo", {
                positionClass: "toast-top-center",
                closeButton: true
              });
              if (!finish)
                this.portage.total_containers -= selectedUnassigned.length;
              this.selectedAssigned = [];
              this.selectedUnassigned = [];

              response.requeriments.map(rq => {
                let index = rqs.findIndex(r => r.id === rq.id);
                if (finish) rqs.splice(index, 1, rq);
                else rqs.splice(index, 1);
              });
            },
            error => {
              this.$toastr.success(error.message, "Porteo", {
                positionClass: "toast-top-center",
                closeButton: true
              });
            }
          );
      }
    },
    selectAppointmentRqs(data) {
      if (data.chargeTypeId) {
        return this.rqs.filter(
          rq => !rq.appointment_code && rq.charge_type_id === data.chargeTypeId
        );
      } else return this.rqs.filter(rq => !rq.appointment_code);
    },
    addAppointments(data) {
      const numAppointments = data.appointmentCodes.length;
      const rqsAvalible = this.selectAppointmentRqs(data);
      if (numAppointments < rqsAvalible.length) {
        const rqs = rqsAvalible.slice(0, numAppointments);
        api
          .post("add_appointments", {
            appointment_date: data.appointmentDate,
            codes: data.appointmentCodes,
            rqs_ids: rqs.map(rq => rq.id)
          })
          .then(
            response => {
              this.$toastr.success(`Codigos de cita agregados.`, "Porteo", {
                positionClass: "toast-top-center",
                closeButton: true
              });

              response.requeriments.map(rq => {
                let index = this.rqs.findIndex(r => r.id === rq.id);
                this.rqs.splice(index, 1, rq);
              });
              this.setContainerByCharge();
            },
            error => {
              this.$toastr.success(error.message, "Porteo", {
                positionClass: "toast-top-center",
                closeButton: true
              });
            }
          );
      }
    }
  },
  computed: {
    unassignedRqs: {
      get: function() {
        return this.rqs.filter(rq => !rq.truck_id);
      },
      set: function(data) {
        this.rqs = data;
      }
    },
    assignedRqs: {
      get: function() {
        return this.rqs.filter(rq => {
          let condition = true;
          if (this.search) {
            condition = rq.truck
              ? rq.truck.plate.toLowerCase().includes(this.search.toLowerCase())
              : false;
          }

          return rq.truck_id && condition;
        });
      },
      set: function(data) {
        this.rqs = data;
      }
    }
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    updateRequeriment: function(rq) {
      let index = this.rqs.findIndex(r => r.id === rq.id);
      if (index >= 0) {
        this.rqs.splice(index, 1, rq);
      }
    }
  }
};
</script>
